import React, { Component } from 'react';
import { formatToCurrency } from "../../../Tools/formatToCurrency";

class InvoiceSummary extends Component {
	constructor(props) {
		super(props);
	}

	render () 
	{
		const {
			total,
			sales_tax,
			balance_due,
			previous_balance,
			total_paid
		} = this.props;

		return (
			<div className="gray_box">
				<div className="card-body">
					<div className="flex">
						<div className="flex-1">
							<h2 className="mb-0" style={{color: "#297c78"}}>Invoice Summary</h2>
							<hr></hr>
						</div>
						<div className="flex-1" style={{justifyContent: "space-between", display: "flex", marginBottom: "2%"}}>
							<span className="text-right">Total</span>
							<span style={{color: "lightslategray"}}>${formatToCurrency(total)}</span>
						</div>
						<div className="flex-1" style={{justifyContent: "space-between", display: "flex", marginBottom: "2%"}}>
							<span className="text-right">Sales Tax</span>
							<span style={{color: "lightslategray"}}>${formatToCurrency(sales_tax)}</span>
						</div>
						<div className="flex-1" style={{justifyContent: "space-between", display: "flex", marginBottom: "2%"}}>
							<span className="text-right">Amount Received</span>
							<span style={{color: "lightslategray"}}>${formatToCurrency(total_paid)}</span>
						</div>
						<div className="flex-1" style={{justifyContent: "space-between", display: "flex", marginBottom: "2%"}}>
							<span className="text-right">Previous Balance</span>
							<span style={{color: "lightslategray"}}>${formatToCurrency(previous_balance)}</span>
						</div>
						<div className="flex-1" style={{justifyContent: "space-between", display: "flex", marginBottom: "2%"}}>
							<span className="text-right" style={{fontSize: "15px", fontWeight: "bold"}}>Total Due</span>
							<span style={{color: "gray", fontSize: "15px", fontWeight: "bold"}}>${formatToCurrency(balance_due)}</span>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default InvoiceSummary;